import Vue from "vue";
import Component from "vue-class-component";
import { useNotifierStore } from "@/shared/store/notifier";


/**
 * @deprecated This mixin should not be used in a any future Vue components
 */
@Component
export class ErrorsMixin extends Vue {

    notifierStore = useNotifierStore();

    isSubmitting = false;

    showError (message: string): void {
        this.notifierStore.setDanger(message);
        window.scrollTo({
            behavior: "smooth",
            left: 0,
            top: 0
        });
    }

    handleError (err: any): void {
        this.isSubmitting = false;

        if (typeof err === "string") {
            this.showError(err);
            return;
        }

        if (!err) {
            this.showError("Error processing your request. Please try again later");
            return;
        }

        if (err.payload) {
            err = err.payload;
        }

        if (err.response) {
            err = err.response;
        }

        if (err.data) {
            err = err.data;
        }

        let message = "Error processing your request. Please try again later";
        if (err.errorMessage) {
            message = err.errorMessage;
        } else if (err.message) {
            message = err.message;
        }

        this.showError(message);
    }
}